import React, {Component} from 'react';
import {SortableTableHeader} from "../../../components/table/sortable-table-header";

export default class UserTableHeader extends Component
{
  static Layout = [
    { column: "userName", width: 3, name: "User Name" },
    { column: "firstName",width: 2, name: "First Name" },
    { column: "surname",width: 2, name: "Last Name" },
    { column: "lastActive", width: 2, name: "Last Login" },
    { column: "createdDate", width: 2, name: "Created" },
    { column: "isReset", width: 1, name: "Status" },
    { column: "latestPortalPolicyAccepted", width: 1, name: "Policy Accepted" },
    { column: "action", width: 4, name: "Actions" },
  ];

  render() {
    return (<SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={UserTableHeader.Layout}/>)
  }
}